import React from 'react';
import ReactTooltip from 'react-tooltip'
import Form from '../../../components/common/Form';
import InfoCircle from '../../common/InfoCircle';

class CustomSinglePostPreview extends Form {
    constructor(props) {
        super(props);
        this.state = {
            done: false,
            data: {
                email: "",
                password: ""
            },
            errors: {},
            // broadCastNumOfSubscribers: props.broadCastNumOfSubscribers || 0
        };
    }

    render() {
        let props = this.props;
        // let broadCastNumOfSubscribers = this.state.broadCastNumOfSubscribers;

        return (
            <div className="col-md-6 feed-col">
                <div className="section m-lg-b">
                    <ReactTooltip/>
                        <div className="form-group choose-platform m-sm-b">
                            { props.type === 'preview' ?
                                <div className="row">
                                    <label htmlFor="post-link" className="preview-label">Preview</label>
                                    <ReactTooltip/>
                                    <div className="col-xs-3  m-s-t">
                                        <div className="preview-platform active">
                                            <span className="fab fa-facebook-messenger"></span>
                                        </div>
                                    </div>
                                </div>
                                :
                                <div className="row">
                                    <p className='text-bold custom-subtitle'>
                                        Post Preview <InfoCircle
                                            icon={'question'}
                                            infoCircleContent={
                                                <p className='info-circle-content' >See how your post will look</p>
                                            }
                                        />
                                    </p>
                                    <ReactTooltip/>
                                    <div className="col-xs-3  m-s-t">
                                        <div className="preview-platform active">
                                            <span className="fab fa-facebook-messenger"></span>
                                        </div>
                                    </div>
                                </div>
                            }
                        </div>
                        <div className="preview-screen">
                            {
                                this.props.messageContent !== '' ?
                                    <div className="preview-msg">
                                        {this.props.messageContent}
                                    </div> :
                                    ''
                            }
                            {/*{ console.log('Props in CustomSinglePostPreview: ', props )}*/}
                            <div className="preview-post">
                                {props.loading_title ?
                                    <div className="loader" style={{margin: "10px 0 10px 15%"}}></div>
                                    :
                                    <div className="preview-post-picture post-picture-style"
                                         style={{backgroundImage: "url(" + props.previewLink + ")"}}>
                                    </div>
                                }
                                <div className="preview-post-title">
                                    {props.previewTitle}
                                </div>
                                <div className="preview-post-button text-center">
                                    Read
                                </div>
                                <div className="preview-post-button text-center">
                                    Share
                                </div>
                            </div>
                        </div>
                </div>

            </div>
        )
    }
}

export default CustomSinglePostPreview